<template>
  <div>
    <table :class="{ 'hideMobile':isMobile }">
      <thead>
        <th v-for="header in tableHeader"
          :class="{'sort':sort.active === header.code && !!header.code, 'sortable':!!header.code}"
          @click="sortTable(header.code)">
          <span>{{ header.label }}</span>
          <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
        </th>
        <th></th>
        <th><i class="stripe-icon fab fa-stripe-s"></i></th>
      </thead>
      <tbody>
        <tr v-for="(trx, index) in transactions" v-show="!isLoading" :key="index">
          <td class="date">{{ trx.date }}</td>
          <td>{{ trx.serviceArea }}</td>
          <td><a v-bind:href="'/#/provider/' + trx.providerId" target="_blank">{{ trx.company }}</a></td>
          <td class="rsvpId">
            <a v-bind:href="'/#/reservation/' + trx.rsvpId"
              @mouseover="showToolTip(index, trx)"
              @mouseout="hoverRsvpInfo = ''" v-if="!!trx.rsvpId"
              target="_blank">{{ convertBrand(trx.brandId) + trx.rsvpId }}</a>
            <a v-bind:href="'/#/package/' + trx.pkgId" class="package-link"
              target="_blank" v-else>
              {{ trx.pkgId }}
              <i class="fas fa-box"></i>
            </a>
            <transition name="slide-right">
              <div class="popup" v-show="hoverRsvpInfo === index">
                <div class="datetime">
                  <i class="far fa-clock"></i>
                  <span>{{ trx.pickupDate }}</span>
                </div>
                <div class="field">
                  <span class="label">
                    <i class="fas fa-map-marker-alt pickup"></i>
                    {{ $t('transactions.list.pickup') }}
                  </span>
                  <span class="value">{{ trx.pickup }}</span>
                </div>
                <div class="field" v-if="extraStops[trx.rsvpId] && extraStops[trx.rsvpId] !== 'none'">
                  <span class="label">
                    <i class="fas fa-map-marker-alt pickup"></i>
                    Stop
                  </span>
                  <span class="value" v-if="extraStops[trx.rsvpId] === 'loading'"><i class="fas fa-spinner fa-spin"></i></span>
                  <span class="value" v-else v-html="extraStops[trx.rsvpId]"></span>
                </div>
                <div class="field" v-if="!trx.isCharter">
                  <span class="label">
                    <i class="fas fa-map-marker-alt dropoff"></i>
                    {{ $t('transactions.list.dropoff') }}
                  </span>
                  <span class="value">{{ trx.dropoff }}</span>
                </div>
                <div class="paxLuggage-box">
                  <span class="paxLuggage">
                    <i class="fas fa-user-friends"></i>
                    {{ trx.passenger }}
                  </span>
                  <span class="paxLuggage">
                    <i class="fas fa-suitcase"></i>
                    {{ trx.luggage }}
                  </span>
                  <!-- <span>{{ trx.service }}</span> -->
                </div>
              </div>
            </transition>
          </td>
          <td>
            <span v-if="trx.eventId === '0'">--</span>
            <span v-else>{{ trx.eventId }}</span>
          </td>
          <td class="type">
            <span v-if="trx.pkgId" class="package">PKG</span>
            <span :class="[trx.type]" v-else>{{ trx.type }}</span>
          </td>
          <td>
            <span :class="['service-label', trx.serviceCode]" v-if="useOldQuatation">{{ trx.serviceLabel }}</span>
            <span class="service-label" :style="{backgroundColor: trx.serviceType.color}" v-else>{{ trx.serviceType.label }}</span>
          </td>
          <td>
            <span v-if="trx.pkgId">--</span>
            <a v-bind:href="'/#/consumer/' + trx.consumerId" target="_blank"
              v-else>{{ trx.firstName + ' ' + trx.lastName }}</a>
          </td>
          <td>
            <span v-if="trx.pkgId">--</span>
            <span v-else>{{ trx.email }}</span>
          </td>
          <td>
            <span v-if="trx.pkgId">--</span>
            <a @click="call(trx)" v-else>{{ trx.mobile }}</a>
          </td>
          <td>
            <span v-if="trx.pkgId">--</span>
            <span v-else>{{ trx.creditCard }}</span>
          </td>
          <td class="source">
            <label v-if="trx.pkgId">--</label>
            <span :class="[trx.source]" v-else>{{ trx.source }}</span>
          </td>
          <td class="final-offer">{{ toFixed(trx.finalOffer) }}</td>
          <td class="charge-amount">{{ toFixed(trx.chargedAmount) }}</td>
          <td class="bonus">{{ toFixed(trx.bonus) }}</td>
          <td class="promo-used">{{ toFixed(trx.promo) }}</td>
          <td class="cancel-fee">{{ toFixed(trx.cancelFee) }}</td>
          <td><span :class="['status-label', trx.status, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', checkReclaimed(trx)]">{{ relabel(trx) }}</span></td>
          <td class="refund">
            <div v-if="trx.status === 'Pending Refund' && trx.notes === 'NOT_PROCESSED' && trx.creditCard !== 'Terminal'">
              <i class="fas fa-spinner fa-lg fa-spin"
                v-if="processRefund.loading && refundTarget === trx.id"></i>
              <i class="fas fa-hand-holding-usd fa-lg" v-else
                @click="showProcessRefundModal(trx)"></i>
            </div>
            <div v-if="trx.status === 'Credit Conversion' && trx.notes !== 'RECLAIMED' && trx.creditCard !== 'Terminal'">
              <i class="fas fa-spinner fa-lg fa-spin"
                v-if="cxlConvert.loading && refundTarget === trx.id"></i>
              <i class="fas fa-hand-holding-usd fa-lg" v-else
                @click="showConvertCreditModal(trx)"></i>
            </div>
            <div v-else-if="!hideRefundIcon(trx) && refundAccess && trx.creditCard !== 'Terminal'">
              <i class="fas fa-spinner fa-lg fa-spin"
                v-if="refundLoading && refundTarget === trx.id"></i>
              <i class="fas fa-hand-holding-usd fa-lg" v-else
                @click="checkCancellationFee(trx)"></i>
            </div>

            <!-- <div v-if="refundCreditModal(trx)">
              <i class="fas fa-hand-holding-usd fa-lg"
                @click="refundCredit(trx)"></i>
            </div> -->
          </td>
          <td>
            <span v-if="trx.paymentURL === null">--</span>
            <a v-else :href="trx.paymentURL" target="_blank"><i class="fa fa-link"></i></a>
          </td>
        </tr>

        <tr class="special" v-show="isLoading">
          <td colspan="20" class="table-block">
            <transition name="slide-up">
              <div class="loader" v-show="isLoading">
                <i class="fas fa-spinner fa-spin"></i>
                {{ $t('transactions.list.loading') }}
              </div>
            </transition>
          </td>
        </tr>

        <tr class="special" v-show="transactions.length === 0 && !isLoading">
          <td colspan="20" class="table-block">
            <transition name="slide-up">
              <div class="empty" v-show="transactions.length === 0 && !isLoading">
                <i class="far fa-frown-open fa-3x"></i>
                {{ $t('transactions.list.empty') }}
              </div>
            </transition>
          </td>
        </tr>
      </tbody>
    </table>

    <div :class="[{'hideDesktop':!isMobile}, 'trans-cards']">
      <div class="trans-card" v-for="(trx, index) in transactions" v-show="!isLoading" :key="index">
        <table>
          <div class="card-header">
            <div class="time">
              {{trx.date}}
            </div>
            <div class="amount">
              <span v-if="trx.paymentURL === null">{{ toFixed(trx.chargedAmount) }}</span>
              <a v-else :href="trx.paymentURL" target="_blank">{{ toFixed(trx.chargedAmount) }} <i class="fa fa-link"></i></a>
            </div>
          </div>
          <div class="tags">
            <div class="rsvp-stats">
              <div class="type">
                <span v-if="trx.pkgId" class="package">PKG</span>
                <span :class="[trx.type]" v-else>{{ trx.type }}</span>
              </div>
              <div>
                <span :class="['service-label', trx.serviceCode]" v-if="useOldQuatation">{{ trx.serviceLabel }}</span>
                <span class="service-label" :style="{backgroundColor: trx.serviceType.color}" v-else>{{ trx.serviceType.label }}</span>
              </div>
            </div>
            <div class="status">
              <div><span :class="['status-label', trx.status, trx.notes === 'NOT_PROCESSED' ? 'NOT_PROCESSED' : '', checkReclaimed(trx)]">{{ relabel(trx) }}</span></div>
              <div class="refund">
                <div v-if="trx.status === 'Pending Refund' && trx.notes === 'NOT_PROCESSED'">
                  <i class="fas fa-spinner fa-lg fa-spin"
                    v-if="processRefund.loading && refundTarget === trx.id"></i>
                  <i class="fas fa-hand-holding-usd fa-lg" v-else
                    @click="showProcessRefundModal(trx)"></i>
                </div>
                <div v-if="trx.status === 'Credit Conversion' && trx.notes !== 'RECLAIMED'">
                  <i class="fas fa-spinner fa-lg fa-spin"
                    v-if="cxlConvert.loading && refundTarget === trx.id"></i>
                  <i class="fas fa-hand-holding-usd fa-lg" v-else
                    @click="showConvertCreditModal(trx)"></i>
                </div>
                <div v-else-if="!hideRefundIcon(trx) && refundAccess">
                  <i class="fas fa-spinner fa-lg fa-spin"
                    v-if="refundLoading && refundTarget === trx.id"></i>
                  <i class="fas fa-hand-holding-usd fa-lg" v-else
                    @click="checkCancellationFee(trx)"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="title">
            <div class="rsvpId">
              <a v-bind:href="'/#/reservation/' + trx.rsvpId"
              @mouseover="hoverRsvpInfo = index"
              @mouseout="hoverRsvpInfo = ''" v-if="!!trx.rsvpId"
              target="_blank">{{ convertBrand(trx.brandId) + trx.rsvpId }}</a>
              <a v-bind:href="'/#/package/' + trx.pkgId" class="package-link"
                target="_blank" v-else>
                {{ trx.pkgId }}
                <i class="fas fa-box"></i>
              </a>
            </div>
            <div>
              <span v-if="trx.eventId === '0'">--</span>
              <span v-else>{{ trx.eventId }}</span>
            </div>
          </div>

          <div class="clock">
            <i class="fas fa-clock icon"></i>
            <span>{{ trx.pickupDate }}</span>
          </div>

          <div class="pickup">
            <i class="fas fa-map-marker-alt icon"></i>
            <span>{{trx.pickup}}</span>
          </div>

          <div class="dropoff">
            <i class="fas fa-location-arrow icon"></i>
            <span>{{trx.dropoff}}</span>
          </div>

          <div>
            <i class="fas fa-user-friends icon"></i>
            {{ trx.passenger }}
            <i class="fas fa-suitcase icon"></i>
            {{ trx.luggage }}
          </div>

          <div class="toggle-div">
            <div class="name">
              <i class="fas fa-user icon"></i>
              <span v-if="trx.pkgId">--</span>
              <a v-bind:href="'/#/consumer/' + trx.consumerId" target="_blank"
              v-else>{{ trx.firstName + ' ' + trx.lastName }}</a>
            </div>
            <div class="toggle" @click="trx.isCollapsible = !trx.isCollapsible">
              <span v-if="!trx.isCollapsible">
                <i class="fas fa-plus-circle"></i>
              </span>
              <span v-else>
                <i class="fas fa-minus-circle"></i>
              </span>
            </div>
          </div>

          <transition name="slide-down">
            <div v-show="trx.isCollapsible" class="see-more">
              <div>
                <i class="fas fa-envelope icon"></i>
                <span v-if="trx.pkgId">--</span>
                <span v-else>{{ trx.email }}</span>
              </div>

              <div>
                <i class="fas fa-phone icon"></i>
                <span v-if="trx.pkgId">--</span>
                <a @click="call(trx)" v-else>{{ trx.mobile }}</a>
              </div>

              <div>
                <i class="fas fa-credit-card icon"></i>
                <span v-if="trx.pkgId">--</span>
                <span v-else>{{ trx.creditCard }}</span>
              </div>

              <div class="amount">
                <span class="label">Final Offer:</span>
                <span class="value">{{ toFixed(trx.finalOffer) }}</span>
              </div>

              <div class="amount">
                <span class="label">Charged Amount:</span>
                <span class="value">{{ toFixed(trx.chargedAmount) }}</span>
              </div>

              <div class="amount">
                <span class="label">Bonus:</span>
                <span class="value">{{ toFixed(trx.bonus) }}</span>
              </div>

              <div class="amount">
                <span class="label">Promo Used:</span>
                <span class="value">{{ toFixed(trx.promo) }}</span>
              </div>

              <div class="amount">
                <span class="label">Cancel Fee:</span>
                <span class="value">{{ toFixed(trx.cancelFee) }}</span>
              </div>

              <div class="service-area">
                <div class="source">
                  <label v-if="trx.pkgId">--</label>
                  <span :class="[trx.source]" v-else>{{ trx.source }}</span>
                </div>
                <div class="service">
                  {{ trx.serviceArea }}
                </div>
              </div>

            </div>
          </transition>
        </table>
      </div>
    </div>

    <div class="column small-6">
      <div class="perPage">
        <span>{{ $t('transactions.list.display') }}</span>
        <select v-model="perPage" :disabled="isLoading">
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <span>{{ $t('transactions.list.resultsPerPage') }}</span>
      </div>
    </div>

    <div class="column small-6">
      <div class="pagination">
        <div class="displaying" v-if="transactions.length">
          {{ $t('transactions.list.displaying', displayingData) }}
        </div>
        <div class="paging">
          <a :class="{'page page-btn back':true, 'disabled':pagingDisable.prev}"
            @click="getTrasactions('prev', false)">
            <i class="fas fa-fw fa-chevron-left"></i>
          </a>
          <select class="page page-number" :disabled="pagingDisable.select"
            v-model="page">
            <option v-for="page in totalPage" :value="page">{{ page }}</option>
          </select>
          <a :class="{'page page-btn next':true, 'disabled':pagingDisable.next}"
            @click="getTrasactions('next', false)">
            <i class="fas fa-fw fa-chevron-right"></i>
          </a>
          </a>
        </div>
      </div>
    </div>

    <div class="clear"></div>

    <div v-bind:class="{ 'op--modal-container':true, 'hide':!trxErrorModal }"
      @click="trxErrorModal = true">
      <div class="op--modal">
        <div class="op--modal-content">
          <div @click.stop class="other-means-box">
            <div>
              <span class="title">{{ $t('transactions.unableToRefund') }}</span>
              <span class="message">{{ $t('transactions.otherMeans') }}</span>
              <a class="button cta warning block"
                @click="trxErrorModal = false">{{ $t('transactions.close') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'op--modal-container':true, 'hide':!processRefund.show }"
      @click="processRefund.show = false">
      <div class="op--modal">
        <div class="op--modal-content">
          <div @click.stop class="credit-convert-refund">
            <div>
              <!-- <span class="title">{{ $t('transactions.unableToRefund') }}</span> -->
              <span class="message">Are you sure you want to mark this transaction as processed?</span>
              <div class="button cta success small block" @click="processRefundExec">
                <span v-if="!processRefund.loading">Yes</span>
                <span v-else>Loading...</span>
              </div>
              <a @click="processRefund.show = false">No, I changed my mind.</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'op--modal-container':true, 'hide':!cxlConvert.show }"
      @click="cxlConvert.show = false">
      <div class="op--modal">
        <div class="op--modal-content">
          <div @click.stop class="credit-convert-refund">
            <div>
              <!-- <span class="title">{{ $t('transactions.unableToRefund') }}</span> -->
              <span class="message">Are you sure you want to refund this transaction?</span>
              <span class="note">This will remove the credits and refund the transactions for this reservation.</span>
              <div class="button cta success small block" @click="convertCredit">
                <span v-if="!cxlConvert.loading">Yes</span>
                <span v-else>Loading...</span>
              </div>
              <a @click="cxlConvert.show = false">No, I changed my mind.</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-bind:class="{ 'op--modal-container':true, 'hide':!cxlConvert.error }"
      @click="cxlConvert.error = false">
      <div class="op--modal">
        <div class="op--modal-content">
          <div @click.stop class="other-means-box">
            <div>
              <span class="title">{{ $t('transactions.unableToRefund') }}</span>
              <span class="message">{{ cxlConvert.message }}</span>
              <a class="button cta warning block"
                @click="cxlConvert.error = false">{{ $t('transactions.close') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import ApiTransactions from '@/modules/api/transactions'
import ApiTrxRefund from '@/modules/api/transactions/refund'
import services from '@/modules/api/services'

export default {
  name: 'transactions-list',
  props: ['isMobile'],
  data () {
    return {
      tableHeader: [
        { code: 'created', label: this.$t('transactions.list.date') },
        { code: '', label: this.$t('transactions.list.serviceArea') },
        { code: '', label: this.$t('transactions.list.company') },
        { code: 'rsvpId', label: this.$t('transactions.list.rsvpId') },
        { code: 'eventId', label: this.$t('transactions.list.invoiceId') },
        { code: 'isAsap', label: this.$t('transactions.list.type') },
        { code: 'serviceTypeId', label: this.$t('transactions.list.service') },
        { code: '', label: this.$t('transactions.list.customerName') },
        { code: '', label: this.$t('transactions.list.email') },
        { code: '', label: this.$t('transactions.list.mobile') },
        { code: '', label: this.$t('transactions.list.creditCard') },
        { code: '', label: this.$t('transactions.list.source') },
        { code: '', label: this.$t('transactions.list.finalOffer') },
        { code: '', label: this.$t('transactions.list.chargedAmount') },
        { code: '', label: this.$t('transactions.list.bonus') },
        { code: '', label: this.$t('transactions.list.promoUsed') },
        { code: '', label: this.$t('transactions.list.cancelFee') },
        { code: '', label: this.$t('transactions.list.status') }
      ],
      sort: {
        active: 'created',
        isDesc: true
      },
      hoverRsvpInfo: '',
      refundTarget: '',
      refundLoading: false,
      trxErrorModal: false,
      cxlConvert: {
        show: false,
        loading: false,
        data: '',
        error: false,
        message: ''
      },
      processRefund: {
        show: false,
        loading: false,
        data: '',
        error: false,
        message: ''
      },
      seeMore: {
        show: false,
        id: null
      },
      extraStops: []
    }
  },
  computed: {
    sharedService () { return services.getServiceName('shared') },
    transactions () { return this.$store.state.transactions.list },
    perPage: {
      get: function () { return this.$store.state.transactions.perPage },
      set: function (value) {
        this.$store.commit('transactions/setCurrentPage', 0)
        this.$store.commit('transactions/setPerPage', value)
        this.getTrasactions('next', false)
      }
    },
    page: {
      get: function () { return this.$store.state.transactions.currentPage  },
      set: function (value) {
        this.$store.commit('transactions/setCurrentPage', value - 1)
        this.getTrasactions('next', false)
      }
    },
    totalPage () { return Math.ceil(this.$store.state.transactions.total / this.perPage) },
    pagingDisable () {
      return {
        prev: this.isLoading || this.page === 1 || this.totalPage === 0,
        select: this.isLoading || this.totalPage === 0,
        next: this.isLoading || this.page >= this.totalPage || this.totalPage === 0
      }
    },
    displayingData () {
      let trx = this.$store.state.transactions
      let max = trx.currentPage * trx.perPage
      if (max > trx.total) { max = trx.total }
      return {
        min: (trx.currentPage * trx.perPage) - (trx.perPage - 1),
        max: max,
        total: trx.total
      }
    },
    isLoading () { return this.$store.state.transactions.loading },
    isFilterValid () {
      let filter = this.$store.state.transactions.filter
      let format = 'MM/DD/YYYY'
      return (!!filter.search && filter.date === 'all') || (!!filter.dateFrom && !!filter.dateTo &&
        moment(filter.dateFrom, format).format('x') <= moment(filter.dateTo, format).format('x'))
    },
    searchInput () { return this.$store.state.transactions.filter.search },
    _refreshList () { return this.$store.state.transactions.refreshList },
    refundAccess () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminRefund') },
    useOldQuatation () { return CONFIG.useOldQuatation }
  },
  methods: {
    sortTable (code) {
      if (!code) { return }

      if (this.sort.active === code) {
        this.sort.isDesc = !this.sort.isDesc
      } else {
        this.sort.isDesc = true
      }

      this.sort.active = code
      this.$store.commit('transactions/setSortColumn', code)
      this.$store.commit('transactions/setSortIsDesc', this.sort.isDesc)
      this.$store.commit('transactions/setCurrentPage', 0)
      this.getTrasactions('next', false)
    },
    getTrasactions (prevNext, updateStats) {
      let self = this

      if (this.isLoading) { return }

      if (!self.isFilterValid) {
        this.$emit('scrollToTop')
        return
      }

      self.$store.commit('transactions/setLoading', true)
      if (updateStats && !self.searchInput) { self.$store.commit('transactions/setStatsLoading', true) }
      ApiTransactions.getTrasactions(self, { isNext: prevNext === 'next' }, function (res) {
        self.$store.commit('transactions/setLoading', false)
        if (!res.error) {
          if (updateStats && !self.searchInput) {
            self.$store.commit('transactions/setStatsLoading', false)
            self.$store.commit('transactions/setStats', {
              gross: res.stats.revenue,
              credits: res.stats.credits
            })
          }
        }
      })
    },
    resetTransactions () {
      this.$store.commit('transactions/setTransactions', [])
      this.$store.commit('transactions/setSortColumn', 'created')
      this.$store.commit('transactions/setSortIsDesc', true)
      this.$store.commit('transactions/setCurrentPage', 0)
      this.$store.commit('transactions/setPerPage', 20)
      this.$store.commit('transactions/setTotal', 0)
    },
    refreshTransaction () {
      let self = this

      if (this.isLoading) { return }

      self.$store.commit('transactions/setLoading', true)
      self.$store.commit('transactions/setStatsLoading', true)

      ApiTransactions.refreshTransaction(self, {}, function (res) {
        self.$store.commit('transactions/setLoading', false)
        self.$store.commit('transactions/setRefreshList', false)

        if (!res.error) {
          self.$store.commit('transactions/setStatsLoading', false)
          self.$store.commit('transactions/setStats', {
            gross: res.stats.revenue,
            credits: res.stats.credits
          })
        }
      })
    },
    convertBrand (id) {
      let index = CONFIG.brands.findIndex(x => x.id === id)
      if (!id || index === -1) { return CONFIG.brands[0].trxCode.toUpperCase() }

      return CONFIG.brands[index].trxCode.toUpperCase()
    },
    rsvpMouseover (id) {
      this.hoverRsvpInfo = id
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    toFixed (value) {
      if (value && value < 0) {
        return '-$' + Math.abs(parseFloat(value)).toFixed(2)
      }
      return '$' + parseFloat(value).toFixed(2)
    },
    hideRefundIcon (data) {
      let allowedStatus = [
        'Declined', 'Cancelled Prov', 'Cancelled Cons', 'Cancelled Admin',
        'Cancelled Charge', 'Cancelled', 'Unrefunded Cancel', 'Edited Refund',
        'Edited', 'Partial Refund', 'Full Refund', 'Failed', 'Pending Refund',
        'Credit Conversion'
      ]

      let isFullRefunded = ''
      if (data.refundedAmount) {
        if (data.status === 'Promo') {
          isFullRefunded = data.refundedAmount == data.credit
        } else {
          isFullRefunded = data.refundedAmount == data.bidAmount
        }
      }

      let rsvpStateDisallow = data.reservationState !== 'NOSHOW' && data.reservationState !== 'CANCELED'

      if (data.status && data.status !== 'Completed' && data.completed) return true

      return data.pkgId || allowedStatus.indexOf(data.status) > -1 ||
        (data.status !== 'Completed' && data.hasSubTransactionId) ||
        (data.status === 'Authorized' && (data.completed || isFullRefunded)) ||
        (
          ((data.isReservationRefunded && rsvpStateDisallow) || isFullRefunded) &&
          data.status === 'Promo'
        )
    },
    checkCancellationFee (trx) {
      let self = this
      if (self.refundLoading) { return }

      if (!trx.creditCard || trx.creditCard === 'N/A') {
        self.trxErrorModal = true
        return
      }

      if (trx.status === 'Completed' && trx.note !== 'TIP_TRANSACTION') {
        let disable = []
        if (parseFloat(trx.refundedAmount) > 0) { disable.push('full') }
        if (parseFloat(trx.refundedAmount) >= parseFloat(trx.chargedAmount)) {
          disable.push('partial')
          disable.push('credit')
        }
        self.$store.commit('reservationNotes/show', {
          rsvpId: trx.rsvpId,
          action: 'partialRefund',
          actionData: {
            title: self.$t('rsvpNotes.title.refund'),
            id: trx.id,
            disable: disable,
            status: trx.status
          }
        })
        return
      }

      let title = trx.status === 'No Show' ? self.$t('rsvpNotes.title.noShowRefund') : self.$t('rsvpNotes.title.confirmRefund')
      let noCancellationFee = ['Additional Purchase', 'Refund']
      if (noCancellationFee.indexOf(trx.status) > -1) {
        self.$store.commit('reservationNotes/show', {
          rsvpId: trx.rsvpId,
          action: 'fullRefund',
          actionData: {
            title: title,
            id: trx.id,
            amount: 0,
            status: trx.status
          }
        })
        return
      }

      console.log(trx)
      self.refundLoading = true
      self.refundTarget = trx.id
      ApiTrxRefund.getRefundFee(self, trx.id, function (res) {
        self.refundLoading = false
        self.refundTarget = ''
        self.$store.commit('reservationNotes/show', {
          rsvpId: trx.rsvpId,
          action: 'fullRefund',
          actionData: {
            title: title,
            id: trx.id,
            amount: parseFloat(res.amount).toFixed(2)
          }
        })
      })
    },
    refundCreditModal(trx){
      let showModal = trx.notes === 'NOT_PROCESSED' && trx.status === 'Pending Refund'
      return showModal
    },
    refundCredit() {
      let self = this
      self.$store.commit('refundCredit/show', true)
    },
    showProcessRefundModal (trx) {
      this.processRefund.show = true
      this.processRefund.data = trx
    },
    processRefundExec () {
      let self = this
      let trx = self.processRefund.data
      if (self.refundLoading || self.processRefund.loading) { return }
      self.processRefund.loading = true
      self.refundLoading = true
      self.refundTarget = trx.id
      self.$sdk.post('/transaction/' + trx.id + '/markprocessed', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.processRefund.show = false
        self.processRefund.loading = false
        self.refundLoading = false
        self.refundTarget = ''
        self.refreshTransaction()
      })
    },
    showConvertCreditModal (trx) {
      this.cxlConvert.show = true
      this.cxlConvert.data = trx
    },
    convertCredit () {
      let self = this
      let trx = self.cxlConvert.data
      if (self.refundLoading || self.cxlConvert.loading) { return }

      self.cxlConvert.loading = true
      self.refundLoading = true
      self.refundTarget = trx.id
      self.$sdk.post('/transaction/' + trx.id + '/deconvert', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.cxlConvert.show = false
        self.cxlConvert.loading = false
        self.refundLoading = false
        self.refundTarget = ''

        if (r.error) {
          self.cxlConvert.error = true
          self.cxlConvert.message = r.error.message
          if (r.error.message === 'Not enough credits') {
            self.cxlConvert.message = 'Not enough credits are left in the consumer account. Some could have been used in other reservations.'
          }
          return
        }
        self.refreshTransaction()
      })
    },
    relabel (trx) {
      if (trx.status !== 'Credit Conversion') {
        return trx.status
      }
      return 'Open Credit'
    },
    checkReclaimed (trx) {
      if (trx.transactionType !== 'CONVERT_CREDIT ') {
        return ''
      }

      if (trx.transactionType === 'CONVERT_CREDIT ' && trx.notes === 'RECLAIMED') {
        return 'RECLAIMED'
      }
    },
    showToolTip (index, data) {
      this.hoverRsvpInfo = index
      if (data.hasExtraStop) {
        this.getExtraStops(data.rsvpId)
      }
    },
    getExtraStops (id) {
      let self = this

      if (self.extraStops[id]) { return }

      self.extraStops[id] = 'loading'
      self.$sdk.get(`/admin/rsvp/${id}/extrastops`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error || !r.list.length) {
          self.extraStops[id] = 'none'
        } else {
          r.list.forEach((stop, index) => {
            if (!index) {
              self.extraStops[id] = ''
            } else {
              self.extraStops[id] += '<br/>'
            }
            self.extraStops[id] += `${stop.address2} ${stop.address1}, ${stop.city}, ${stop.state} ${stop.zipCode}`
          })
        }
        self.$forceUpdate()
      })
    },
  },
  watch: {
    _refreshList: function (value) {
      if (value) {
        this.refreshTransaction()
      }
    }
  },
  mounted () {
    let self = this

    self.resetTransactions()
    self.getTrasactions('next', true)
  }
}
</script>

<style lang="scss" scoped>

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{
      padding: 5px 10px;

      &:last-child{ cursor: default; }
      i{ display: none; }
      & i.stripe-icon { display: inline-block; }
      .fa-sort-up{ vertical-align: -2px; }
      .fa-sort-down{ vertical-align: 2px; }
      &.sortable{
        cursor: pointer;
        color: #333;
        span{
          font-weight: 600;
          text-decoration: underline;
        }
      }
      &.sort i{ display: inline-block; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:nth-child(even) { background: #f3f3f3; }
      &:not(.special):hover { background: #d7dbe4; }
      td{
        padding: 10px 5px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
          .empty i{
            display: block;
            margin-bottom: 5px;
            color: #ddd;
          }
        }
        a{ font-weight: 600; }
      }
    }
  }

  a{ cursor: pointer; }
  .date{
    font-size: 12px;
    color: #777;
    word-spacing: 5px;
    width: 135px;
  }
  .rsvpId{
    position: relative;

    a{
      position: relative;
      z-index: 4;
    }
    .package-link{ text-decoration: none; }
    .popup{
      width: 370px;
      /*height: 130px;*/
      position: absolute;
      top: 0;
      left: calc(100% - 8px);
      z-index: 3;
      border: 1px solid #777;
      border-radius: 3px;
      padding: 5px 10px;
      background: #fbf9bd;
      box-shadow: 1px 1px 3px rgba(0,0,0, .2);
      text-align: left;
      font-size: 13px;

      .datetime{
        color: #555;
        margin-bottom: 5px;
        i{ margin-right: 2px; }
      }
      .field{
        display: flex;
        margin-bottom: 2px;
        .label{
          width: 80px;
          font-weight: 600;
          font-size: 12px;
          color: #444;
        }
        i{ margin-right: 3px; }
        .pickup{ color: #ff8585; }
        .dropoff{ color: #18d22f; }
        .value{
          width: 100%;
          padding-left: 7px;
        }
      }
      .paxLuggage-box{
        margin-top: 10px;
      }
      .paxLuggage{
        display: inline-block;
        margin-right: 10px;
        font-size: 15px;
        border-radius: 3px;
        overflow: hidden;
        border:1px solid #444;
        background: #fafafa;
        line-height: 1;
        padding-right: 5px;

        i{
          background: #444;
          padding: 3px 7px;
          color: #fff
        }
      }
    }
  }
  .type{
    width: 74px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;

    span{
      padding: 3px 5px;
      color: #fff;
      border-radius: 4px;
      &.rsvp{ background: #5771d0; }
      &.asap{ background: #d05757; }
      &.package{ background: #26d97a; }
    }
  }
  .source{
    width: 100px;
    span{
      padding: 3px 5px;
      background: #ccc;
      color: #fff;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 700;

      &.Web{ background: #a26d5d; }
      &.Admin{ background: #2b83f1; }
      &.Android{ background: #78c259; }
      &.iOS{ background: #7fc8de; }
      &.CSR{ background: #bb4a91; }
      &.Provider{ background: #3f3f3f; }
    }
  }
  .final-offer{ width: 85px; }
  .charge-amount{ width: 120px; }
  .promo-used{ width: 100px; }
  .refund i{
    color: #ff5f45;
    font-size: 21px;
    cursor: pointer;
    &.fa-spin{ color: #0D79F2; }
  }
}

.service-label{
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  display: inline-block;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
}

.perPage{
  padding: 15px 0;
  span{
    font-size: 13px;
    color: #555;
    display: inline-block;
  }
  select{
    vertical-align: middle;
    width: 60px;
    margin: 0 5px;
  }
}

.pagination{
  padding: 15px 0;
  text-align: right;

  .displaying{
    display: inline-block;
    margin-right: 10px;
    font-size: 13px;
    vertical-align: -1px;
    color: #555;
  }
  .paging {
    display: inline-block;
    opacity: 1;
    transition: all 250ms;

    &.disabled {
      pointer-events: none;
      opacity: 0.6;
    }

    & .page{
      display: inline-block;
      vertical-align: middle;
      width: auto;

      &:not([disabled]) { cursor: pointer; }
      &:not(:first-child) { margin-left: -5px; }
    }

    & .page-btn {
      background-color: #f5f5f5;
      border: 1px solid rgba(0,0,0,0.25);
      color: #777;
      padding: 5px 5px;
      font-size: 12px;

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }

      & i { line-height: inherit; }

      &.back {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
        border-right: 0;
      }

      &.next {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }

    & .page-number {
      border-radius: 0;
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);
      line-height: inherit;
      font-size: 12px;
      margin: 0;
      width: 50px;
      font-weight: 700;
      padding: 5px 10px;
      color: #333;
      text-align: center;
      appearance: none;
      outline: 0;
      text-align-last:center;
      border-right: 0;
    }
  }
}

.status-label{
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  background: #999;
  display: inline-block;

  &.Purchased, &.Purchase{ background: #4aadf3; }
  &.Completed{ background: #26D97A; }
  &.Promo{ background: #f3904a; }
  &.Edited, &.Refund{ background: #797979; }
  &.No.Show, &.Cancelled, &.Declined{ background: #f54f4f; }
  &.Pending.Refund{
    background: #098769;
    color: #fff;
  }
  &.Pending.Refund.NOT_PROCESSED{
    background: #FFCC00;
    color: #505050;
  }
  &.Credit.Conversion{ background: #29c3c3; }
  &.Credit.Conversion.RECLAIMED{ background: #bbbbbb; }
}

.clear{ clear: both; }

.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}
.other-means-box, .credit-convert-refund{
  background-color: #fff;
  max-width: 440px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  overflow: hidden;
  position: relative;

  .title{
    text-align: center;
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #f25e0d;
  }
  .message{
    font-size: 14px;
    text-align: left;
    display: block;
    margin-bottom: 20px;
  }
}

.credit-convert-refund{
  max-width: 400px;
  .message{
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #555;
  }
  .note{
    text-align: center;
    font-size: 14px;
    color: #555;
    margin-bottom: 30px;
    display: block;
  }
  a{
    text-align: center;
    display: block;
    margin-top: 10px;
    cursor: pointer;
  }
}

.slide-right-enter-active, .slide-right-leave-active { transition: all .3s ease; }
.slide-right-enter, .slide-right-leave-to {
  transform: translateX(-20px) rotateX(50deg);
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px) rotateX(50deg);
  opacity: 0;
}

.hideMobile, .hideDesktop {
  display: none;
}

@media only screen and (max-width: 430px) {
  table {
    font-size: 13px;
    .type {
      width: auto;
      display: flex;
      height: 24px;
      margin-right: 5px;
    }

    > div {
      margin-bottom: 3px;
    }
  }
  .trans-card {
    border: 1px solid #ccc;
    margin-bottom: 15px;
    padding: 8px;
    padding-bottom: 3px;
    border-bottom: 5px solid #aaa9;
    border-radius: 10px;
    background-color: #fff;

    a {
      font-weight: 900;
    }

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .time {
        font-size: 12px;
        color: #777;
        word-spacing: 5px;
      }

      .amount {
        font-weight: 900;
        font-size: 20px;
        a {
          text-decoration: none;
        }
        i {
          font-size: 15px;
        }
      }
    }


    .tags {
      display: flex;
      justify-content: space-between;

      .rsvp-stats {
        display: flex;
        align-items: flex-end;
      }

      .status {
        display: flex;
        .refund {
          i {
            margin-left: 5px;
            font-size: 24px;
          }
        }
      }
    }

    .title {
      display: flex;
      font-size: 16px;
      .rsvpId {
        margin-right: 10px;
        font-weight: 900;
        display: flex;

        .source {
          width: auto;
        }
      }
    }

    .clock {
      i {
        color: #F25E0D;
      }
      span {
        font-size: 13px;
      }
    }

    .pickup {
      i {
        color: #d92626;
      }
    } 

    .dropoff {
      i {
        color: #26D97A;
      }
    }

    .service-area {
      display: flex;
      .source {
        width: auto;
        margin-right: 10px;
      }
    }

    .toggle-div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .toggle {
        font-size: 16px;
        color: #0e79f2;
      }
    }

    .see-more {
      .amount {
        .label {
          font-size: 12px;
        }
      }
      > div {
        margin: 5px 0;
      }
    }
  }
}

.icon {
  color: dimgray;
  font-size: 12px;
}


.slide-down-enter-active, .slide-down-leave-active { transition: all .2s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.pagination {
  display: flex;
  flex-direction: column-reverse;
  .displaying {
    margin-right: 0;
  }

  .paging {
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Transactions/List.vue